import { render, staticRenderFns } from "./ReviewTreeItem.vue?vue&type=template&id=175e7d77&scoped=true&"
import script from "./ReviewTreeItem.vue?vue&type=script&lang=js&"
export * from "./ReviewTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./ReviewTreeItem.vue?vue&type=style&index=0&id=175e7d77&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175e7d77",
  null
  
)

export default component.exports